<div class="selector-container">
	<div class="selector-item" (click)="itemClicked(item)" [ngClass]="{ selected: item.selected }" *ngFor="let item of selectionList">
		{{ item.displayName }}
	</div>
</div>
